import { Component, ChangeDetectionStrategy,  ViewChild,  TemplateRef, OnInit} from '@angular/core';
import {  startOfDay,  endOfDay,  subDays,  addDays,  endOfMonth,  isSameDay,  isSameMonth,  addHours} from 'date-fns';
import { Subject } from 'rxjs';
import {CalendarDateFormatter, CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView} from 'angular-calendar';
import {language} from '../../../language/vn';
import {BsModalService} from 'ngx-bootstrap/modal';
import {EditLichCongTacComponent} from './edit.component';
import {Sessioncommand} from '../../../global/sessioncommand';
import {DatePipe} from '@angular/common';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {ToastrService} from 'ngx-toastr';
import {CalendarNewsService} from '../../../service/calendar/service-calendarnews';
import {FileLichCongTacComponent} from './file.component';
import {CustomDateFormatter} from '../../../service/calendar/custom-calendar-format';
import {CalendarWeek} from '../../../models/calendar/calendarweeks';
import {Week} from '../../../models/calendar/week';
import {WeekService} from '../../../service/calendar/service-week';
import {CalendarNewsWeek} from '../../../models/calendar/calendarnewsweek';
import {CommandUtil} from '../../../global/commandutil';
import {FormatService} from '../../../service/format/service-format';
import {CalendarNews} from '../../../models/calendar/calendarnews';
import {environment} from '../../../../environments/environment';
import {NavItemService} from '../../../service/staff/service-navitem';
import {CalendarReadService} from '../../../service/calendar/service-calendarread';
import {CalendarRead} from '../../../models/calendar/calendarread';
import {CommentLichCongTacComponent} from './comment.component';
import {LichSuLichCongTacComponent} from './lichsu.component';
import {TongHopLichCongTacComponent} from './tonghop.component';
import {RolePermissionService} from '../../../service/security/service-rolepermission';
import {DomSanitizer} from '@angular/platform-browser';
import {NgxPrintModule} from 'ngx-print';
import {CalendarNewsFile} from '../../../models/calendar/calendarnewsfile';
import {EditLichSinhHoatComponent} from './lichsinhhoat.component';
import {CalendarNewsExtra} from '../../../models/calendar/calendarnewsextra';

@Component({
  selector: 'app-views-info-lichcongtac',
  templateUrl: './lichcongtac.component.html',
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }]
})
export class LichCongTacComponent implements OnInit {
  public language= language;
  public currentMonth: number = new Date().getMonth() + 1;
  public currentYear: number = new Date().getFullYear();
  public locale: string = 'vi';
  private moduleName:  string = 'egov.info.lichcongtac';
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  private yearCurrent: number = 0;
  private weekCurrent: number = 1;
  private calendarNewsWeeks: CalendarNewsWeek[] = [];
  private calendarNews: CalendarNews[] = [];
  private weeks: Week[] = [];
  private years: number[] = [];
  private dataCheck: Object[]=[];
  public srFromDate: Date = new Date();
  public srToDate: Date= new Date();
  public strF: string= '';
  public strT: string= '';
  public srTuKhoa: string='';
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public urlExportLichCongTac: string = environment.exportLichCongTac;
  public urlExportDSLichCongTac: string = environment.exportDSLichCongTac;
  public permissionView: boolean = false;
  public permissionDetail: boolean = false;
  public permissionAdd: boolean = false;
  public permissionUpdate: boolean = false;
  public permissionDelete: boolean = false;
  public permissionToanQuyen: boolean = false;
  public permissionDownloadFile: boolean = false;
  public permissionYKienTongHop: boolean = false;
  public permissionShare: boolean = false;
  public permissionYKien: boolean = false;
  public permissionExport: boolean = false;
  public permissionHistory: boolean = false;
  public totalWeek: number = 0;
  public calendarNewsExtra: CalendarNewsExtra;
  private printTitle: string = language.lichcongtac;
  private calendarNewsFiles: CalendarNewsFile[] = [];
  private calendarNewsFileIds: String = "";
  ngOnInit(): void {
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionView = x.findIndex(y => y.action === environment.view || y.action === environment.toanquyen) !== -1;
      if (this.permissionView)
      {
        this.loadEvent();
        this.yearCurrent = this.viewDate.getFullYear();
        for(let i= 2005 ;i <= this.viewDate.getFullYear() + + environment.yearNext; i++)
          this.years.push(i);
        this.weekService.getAll(this.viewDate.getFullYear()).subscribe(data =>
        {
          this.weeks = data;
          let t: number = data.findIndex( x => x.status === true);
          this.weekCurrent = data[t !== -1 ? t : 0].id;
          this.totalWeek = data.length;
          this.loadDataWeek();
        });
        this.formatService.getFirstLastCurrentByMonth().subscribe(
          data => {
            this.srFromDate= new Date(data.firstDate);
            this.srToDate= new Date(data.lastDate);
            this.search();
          });
      }else
        this.rolePermissionService.redirectAccesDenied();
      this.permissionAdd = x.findIndex(y => y.action === environment.add || y.action === environment.toanquyen) !== -1;
      this.permissionDetail = x.findIndex(y => y.action === environment.detail || y.action === environment.toanquyen) !== -1;
      this.permissionUpdate = x.findIndex(y => y.action === environment.update || y.action === environment.toanquyen) !== -1;
      this.permissionDelete = x.findIndex(y => y.action === environment.delete || y.action === environment.toanquyen) !== -1;
      this.permissionDownloadFile = x.findIndex(y => y.action === environment.download || y.action === environment.toanquyen) !== -1;
      this.permissionToanQuyen = x.findIndex(y => y.action === environment.toanquyen) !== -1;
      this.permissionYKienTongHop = x.findIndex(y => y.action === environment.ykientonghop || y.action === environment.toanquyen) !== -1;
      this.permissionShare = x.findIndex(y => y.action === environment.share || y.action === environment.toanquyen) !== -1;
      this.permissionYKien = x.findIndex(y => y.action === environment.ykien || y.action === environment.toanquyen) !== -1;
      this.permissionExport = x.findIndex(y => y.action === environment.print || y.action === environment.toanquyen) !== -1;
      this.permissionHistory = x.findIndex(y => y.action === environment.viewhistory || y.action === environment.toanquyen) !== -1;
    });
  }
  search()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.calendarNewsService.findAllBySearchPaging(this.srTuKhoa, this.strF, this.strT, -1,
      -1, -1, this.currentPage, this.maxSize).subscribe(data => {
      this.calendarNews = data;
    });
    this.calendarNewsService.getCountBySearch(this.srTuKhoa, this.strF, this.strT, -1,
      -1, -1).subscribe(resultCount => {
      this.totalItems= resultCount;
    });
  }

  constructor(
    public calendarNewsService: CalendarNewsService,
    public bsModalService: BsModalService,
    public datePipe: DatePipe,
    public toastr: ToastrService,
    public weekService: WeekService,
    public commandUtil: CommandUtil,
    public formatService: FormatService,
    public rolePermissionService: RolePermissionService,
    public calendarReadService: CalendarReadService,
    public sanitizer: DomSanitizer
  ) {
  }
  public loadDataWeek()
  {
    this.printTitle = language.lichcongtac + ' (' + language.week + ' '+ this.weekCurrent+ ' - '+ this.yearCurrent+')';
    this.calendarNewsService.getByWeekYear(this.weekCurrent, this.yearCurrent).subscribe(x => this.calendarNewsExtra = x);
    this.calendarNewsService.getDataByWeekYear(this.weekCurrent, this.yearCurrent, -1,
      -1, -1).subscribe(data => {
        this.calendarNewsWeeks = data;
        this.loadFiles();
        if(data.filter(k => k.calendars.length > 0).length > 0)
        {
          let calendarRead: CalendarRead = new CalendarRead();
              calendarRead.staffID = Sessioncommand.staffId;
              calendarRead.weekID = this.weekCurrent;
              calendarRead.yearID = this.yearCurrent;
             this.calendarReadService.add(calendarRead).subscribe( {
               next: (datax) => {
                 console.log(datax.id);
               },
               error: error => {
                 console.log(error);
               }
             }) ;
        }



      });
  }
  private loadFiles()
  {
    this.calendarNewsFiles = [];
    if (this.calendarNewsWeeks != null)
    {
      for (let i = 0 ; i < this.calendarNewsWeeks.length; i++)
      {
        for(let y = 0; y < this.calendarNewsWeeks[i].calendars.length; y++)
        {
          for (let k= 0; k< this.calendarNewsWeeks[i].calendars[y].calendarNewsFiles.length; k++)
            if(this.calendarNewsFiles.findIndex(x => x.id === this.calendarNewsWeeks[i].calendars[y].calendarNewsFiles[k].id ) ===-1)
            {
              this.calendarNewsFileIds = this.calendarNewsFileIds +  this.calendarNewsWeeks[i].calendars[y].calendarNewsFiles[k].id.toString() + ",";
              this.calendarNewsFiles.push(this.calendarNewsWeeks[i].calendars[y].calendarNewsFiles[k]);
            }
        }
      }
      this.calendarNewsFileIds += "0" ;
    }
  }
  public nextData()
  {
    this.weekCurrent = Number(this.weekCurrent) + 1;
    if(this.weekCurrent >= this.totalWeek + 1)
    {
      this.yearCurrent =  Number(this.yearCurrent ) + 1;
      this.weekCurrent = 1;
      this.weekService.getAll(this.yearCurrent).subscribe(data =>
      { this.weeks = data;
        this.totalWeek = data.length;
        this.loadDataWeek();
      });
    }else
      this.loadDataWeek();

  }
  public beforeData()
  {
    this.weekCurrent = Number(this.weekCurrent) - 1;
    if(this.weekCurrent == 0)
    {
      this.yearCurrent = Number(this.yearCurrent ) -1;
      this.weekService.getAll(this.yearCurrent).subscribe(data =>
      { this.weeks = data;
        this.totalWeek = data.length;
        this.weekCurrent = this.totalWeek;
        this.loadDataWeek();
      });
    }else
      this.loadDataWeek();
  }
  public actions: CalendarEventAction[] = [
    {
      label: '<i class="icon-pencil"></i>',
      a11yLabel: language.update,
      onClick: ({ event }: { event: CalendarEvent }): void => {
         this.edit(Number(event.id));
      },
    },
    {
      label: '<i class="icon-trash"></i>',
      a11yLabel: language.delete,
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
            this.showConfirmationModal(Number(event.id));
      },
    },
    {
      label: '<i class="icon-paper-clip"></i>',
      a11yLabel: language.filedinhkem,
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        if (this.permissionToanQuyen || this.permissionDownloadFile)
          this.download(Number(event.id));
      },
    }
  ];
  public loadWeek(year : number)
  {
    this.weekService.getAll(year).subscribe(data => this.weeks = data);
  }
  public loadEvent()
  {
    this.currentYear=this.viewDate.getFullYear();
    this.currentMonth= this.viewDate.getMonth()+1;
    this.events=[];
    this.calendarNewsService.findByMonth(this.currentMonth, this.currentYear,-1,
      -1, -1).subscribe( x =>{
        for(let i=0; i<x.length;i++)
        {
          let colorsItem: any = {
            color: {
              primary: x[i].bgColor,
              secondary: x[i].bgColor,
            }
          };

          this.events.push(
            {
              id: x[i].id,
              start: new Date(this.datePipe.transform(x[i].tuNgay,'yyyy-MM-dd')+ ' '+ (x[i].tuGio !== null ? x[i].tuGio : '00:00')),
              end: new Date(this.datePipe.transform(x[i].denNgay,'yyyy-MM-dd')+ ' '+  (x[i].denGio !== null ? x[i].denGio : '23:59')),
              title: x[i].noiDung,
              color: colorsItem.color,
              actions: this.permissionToanQuyen || this.permissionUpdate || this.permissionDelete ? this.actions : null,
              resizable: {
                beforeStart: true,
                afterEnd: true,
              },
              draggable: true,
            }
          );
        }
        this.refresh.next();
    });

  }
  public refresh: Subject<any> = new Subject();
  public activeDayIsOpen: boolean = true;
  public edit(id: number): void {
    if(this.permissionToanQuyen || this.permissionUpdate) {
      const modalEdit = this.bsModalService.show(EditLichCongTacComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<EditLichCongTacComponent>modalEdit.content).edit(
        id
      );
      (<EditLichCongTacComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.loadEvent();
          this.loadDataWeek();
          this.search();
          Sessioncommand.notification = false;

        }
      });
    }else
    {
      this.toastr.error(language.message_not_permission, language.message);
    }
  }
  public editLichSinhHoat(): void {
    if(this.permissionToanQuyen || this.permissionUpdate) {
      const modalEdit = this.bsModalService.show(EditLichSinhHoatComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<EditLichSinhHoatComponent>modalEdit.content).edit(
        this.weekCurrent, this.yearCurrent
      );
      (<EditLichSinhHoatComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.loadEvent();
          this.loadDataWeek();
          this.search();
          Sessioncommand.notification = false;

        }
      });
    }else
    {
      this.toastr.error(language.message_not_permission, language.message);
    }
  }
  public download(id: number): void {
    const modalEdit = this.bsModalService.show(FileLichCongTacComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<FileLichCongTacComponent>modalEdit.content).edit(
      id
    );
    (<FileLichCongTacComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public yKien(): void {
    const modalEdit = this.bsModalService.show(CommentLichCongTacComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<CommentLichCongTacComponent>modalEdit.content).edit(
      this.weekCurrent, this.yearCurrent
    );
    (<CommentLichCongTacComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public lichSu(id: number): void {
    const modalEdit = this.bsModalService.show(LichSuLichCongTacComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<LichSuLichCongTacComponent>modalEdit.content).show(
      id
    );
    (<LichSuLichCongTacComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public yKienTongHop(): void {
    const modalEdit = this.bsModalService.show(TongHopLichCongTacComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopLichCongTacComponent>modalEdit.content).edit(
      this.weekCurrent, this.yearCurrent
    );
    (<TongHopLichCongTacComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public showConfirmationModal(id: number): void {
    if(this.permissionToanQuyen || this.permissionDelete) {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(id);
        }
      });
    }else
    {
      this.toastr.error(language.message_not_permission, language.message);
    }
  }
  deleteItem(id: number)
  {
    this.calendarNewsService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.loadEvent();
        this.loadDataWeek();
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {

    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
                      event,
                      newStart,
                      newEnd,
                    }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });

  }
  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('printLichTuan').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
            <head>
          <title>${language.lichcongtac}</title>
          <style>
                    .table-bordered {
                      border: 1px solid #c8ced3;
                    }
                    .table {
                      width: 100%;
                      margin-bottom: 1rem;
                      color: #23282c;
                    }
                    table {
                      border-collapse: collapse;
                    }
                    .table thead th {
                      vertical-align: bottom;
                      border-bottom: 2px solid #c8ced3;
                    }
                    .table th {
                      background: linear-gradient(180deg, #ffa91c 0%, #ea5c06 100%);
                      color: #fff;
                    }
                    .table th, .table td {
                      padding: 0.75rem;
                      vertical-align: top;
                      border-top: 1px solid #c8ced3;
                    }
                    th {
                      text-align: inherit;
                    }
          </style>
        </head>
            <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
}
